import { Text } from '@ltvco/refresh-lib/theme';

import { AudioPlayerWrapper } from './components';

interface OralArgumentAudioProps {
  downloadUrl: string | null;
}

export const OralArgumentAudio = ({ downloadUrl }: OralArgumentAudioProps) => {
  if (downloadUrl) {
    return (
      <AudioPlayerWrapper>
        <audio
          controls
          style={{
            width: '100%',
            height: '40px',
          }}
        >
          <source src={downloadUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </AudioPlayerWrapper>
    );
  }

  return (
    <Text variant="body2" color="text.secondary">
      No audio available.
    </Text>
  );
};
